module.exports = __webpack_public_path__ + "img/yq.eedabf3b.png";